export enum FeatureFlag {
  ActivityAiGenerator = "ai_generated_description",
  ActivityCanCreateValues = "activity_can_create_values",
  ActivityFeed = "activity_feed",
  ActivityPhases = "activity_phases",
  ApiReporting = "api_reporting",
  AuditAllocationWindows = "audit_allocation_windows",
  AuditPlanner = "audit_planner",
  AutoSaml = "auto_saml",
  BookingModule = "booking_module",
  Chameleon = "chameleon",
  Chat = "chat",
  DarkMode = "dark_mode",
  Emails = "emails",
  EngagementBlueprints = "project_team_templates",
  EngagementEconomics = "engagement_economics",
  EngagementFeedback = "engagement_feedback",
  EngagementKPIs = "engagement_kpis",
  Facebook = "facebook",
  AnalyticsModule = "analytics_module",
  Instagram = "instagram",
  LearningAndDevelopment = "learning_and_development",
  LinkedinSignin = "linkedin_signin",
  CvExportTranslation = "cv_export_translation",
  CustomFieldsTranslations = "custom_fields_translations",
  NativeNotifications = "native_notifications",
  PasswordSignin = "password_signin",
  PowerBI = "powerbi_dashboard",
  ProfileExporter = "profile_exporter",
  ReportsTo = "reports_to",
  RequestAccess = "request_access",
  RequireAssignee = "require_assignee",
  SamlSignin = "saml_signin",
  SecureDomains = "secure_domains",
  Segments = "segments",
  SelfInactivation = "self_inactivation",
  ShowActivityId = "show_activity_id",
  ShowSkillCategories = "show_skill_categories",
  ShowUtilization = "show_utilization",
  SignInAdminAsSomeone = "sign_in_admin_as_someone",
  SkillsFramework = "skills_framework",
  SkillsFrameworkOnProfile = "skill_frameworks_on_profile",
  SuspendedProfiles = "suspended_profiles",
  TalentMarketplace = "talent_marketplace",
  Twitter = "twitter",
  UnbiasedAllocation = "unbiased_allocation",
  Website = "website",
  EditableAuditRoles = "editable_audit_roles",
  AuditEngagementReset = "audit_engagement_reset",
  FinancialCalendar53weeks = "reports_calendar_53_weeks",
  ReportCalendarsArchive = "reports_calendar_archive",
  WorkflowPlanner = "workflow_planner",
  ReportPreview = "reports_rows_preview"
}
